// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"171d976b","453":"c081e8f2","455":"530d7f69","661":"54aa88f8","716":"a70b85cb","970":"753e672b","977":"36ccf263"}[chunkId] + ".chunk.js";
};